import ChatFilesModal from './ChatFilesModal.component';

export default ChatFilesModal;
